import React, { useState } from 'react';
import axios from 'axios';
import styles from '../css/Footer.module.css';
import { API_CONFIG } from '../apiConfig';

const Footer = () => {
    const [nombre, setNombre] = useState('');
    const [correo, setCorreo] = useState('');
    const [statusMsg, setStatusMsg] = useState({ text: '', type: '' });

    const handleSuscripcion = async (e) => {
        e.preventDefault();
        setStatusMsg({ text: 'Procesando...', type: 'info' });

        try {
            await axios.post(`${API_CONFIG.SUSCRIBIR}`, {
                nombre: nombre,
                correo: correo,
                telefono: "00000000"
            });

            setStatusMsg({ text: '¡Suscripción exitosa!', type: 'success' });
            setNombre('');
            setCorreo('');
            setTimeout(() => setStatusMsg({ text: '', type: '' }), 4000);
        } catch (error) {
            // 3. MEJORA: Mostrar el error real del backend si existe
            const errorMsg = error.response?.data?.detail || 'Error al suscribirse.';
            setStatusMsg({ text: errorMsg, type: 'error' });
        }
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.footerContent}>
                {/* BLOQUE 1: MARCA */}
                <div className={styles.footerBrand}>
                    <img src="/Logo-Iump-Concon.ico" alt="Logo" className={styles.footerLogo} />
                    <h3>IUMP CONCÓN</h3>
                    <p className={styles.slogan}>EN EL MONTE DE JEHOVÁ SERÁ PROVISTO</p>
                </div>

                {/* BLOQUE 2: REDES SOCIALES 3D */}
                <div className={styles.socialContainer3D}>
                    <ul className={styles.socialList3D}>
                        <li>
                            <a href="https://www.facebook.com/profile.php?id=100090158649323" target="_blank" rel="noreferrer">
                                <i className="fab fa-facebook-f"></i>
                                <span> - Facebook</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com/@iumpconcon5792" target="_blank" rel="noreferrer">
                                <i className="fab fa-youtube"></i>
                                <span> - YouTube</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/iumpconcon/?hl=es-la" target="_blank" rel="noreferrer">
                                <i className="fab fa-instagram"></i>
                                <span> - Instagram</span>
                            </a>
                        </li>
                    </ul>
                </div>
                {/* BLOQUE 1: MARCA */}
                <div className={styles.footerBrand}>
                    <img src="/Logo-Iump-Concon.ico" alt="Logo" className={styles.footerLogo} />
                    <h3>I.U.M.P</h3>
                    <p className={styles.slogan}>IGLESIA UNIDA METODISTA PENSTECOSTAL</p>
                </div>
            </div>

            <div className={styles.footerBottom}>
                <p>© 2026 IUMP Concón — Equipo Informático IUMP Concón</p>
            </div>
        </footer>
    );
};

export default Footer;